import { render, staticRenderFns } from "./plano-assinar-alterar.vue?vue&type=template&id=6ed91ad2"
import script from "./plano-assinar-alterar.vue?vue&type=script&lang=ts"
export * from "./plano-assinar-alterar.vue?vue&type=script&lang=ts"
import style0 from "./plano-assinar-alterar.vue?vue&type=style&index=0&id=6ed91ad2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports